/**
 * accessCode.js
 *
 * Reads the elevated-tier access code from the URL once (?k=CODE) and persists
 * it for the browser so reloads keep elevated access. The code is distributed
 * via a private link and is never rendered on the public site. It is a
 * rotatable bearer token, not a password; the backend caps and App Check
 * bound the cost even if a code leaks.
 */
const STORAGE_KEY = 'ds_access_code';

function readFromUrl() {
  if (typeof window === 'undefined') return null;
  try {
    return new URLSearchParams(window.location.search).get('k');
  } catch (err) {
    return null;
  }
}

let cached;

export function getAccessCode() {
  if (cached !== undefined) return cached;
  let code = readFromUrl();
  if (code && typeof localStorage !== 'undefined') {
    try { localStorage.setItem(STORAGE_KEY, code); } catch (err) { /* ignore */ }
  }
  if (!code && typeof localStorage !== 'undefined') {
    try { code = localStorage.getItem(STORAGE_KEY); } catch (err) { /* ignore */ }
  }
  cached = code || null;
  return cached;
}
